import { useCallback, useEffect, useState } from 'react'
import { orderRepository } from '../../data/repositories/OrderRepositoryImpl'
import { OrderDetail } from '../../domain/entities/Order'

// Dedicated hook for the Indents review-detail modal — independent of useOrderDetail/OrdersPage.
export const useIndentDetail = (indentId: string | null) => {
  const [detail, setDetail] = useState<OrderDetail | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchDetail = useCallback(async () => {
    if (!indentId) {
      setDetail(null)
      return
    }

    setLoading(true)
    setError(null)
    try {
      const res = await orderRepository.getOrderDetail(indentId)
      setDetail(res)
    } catch (err: unknown) {
      const errorVal = err as Error
      setError(errorVal.message || 'Failed to load indent detail.')
    } finally {
      setLoading(false)
    }
  }, [indentId])

  useEffect(() => {
    fetchDetail()
  }, [fetchDetail])

  return { detail, loading, error, refresh: fetchDetail }
}
